import { Component, EventEmitter, Input, Output, AfterViewInit, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-download-modal',
  templateUrl: './app-download-modal.component.html',
  styleUrls: ['./app-download-modal.component.scss']
})
export class AppDownloadModalComponent implements AfterViewInit, OnChanges {
  @Input() isActive: boolean = false;
  @Output() isClosed = new EventEmitter<void>();
  @ViewChild('modalRef', { static: false }) modalRef: ElementRef;

  ngAfterViewInit() {
    this.toggleModal();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isActive']) {
      this.toggleModal();
    }
  }

  toggleModal() {
    if (typeof window !== 'undefined' && (window as any).bootstrap && this.modalRef) {
      const modal = new (window as any).bootstrap.Modal(this.modalRef.nativeElement);
      if (this.isActive) {
        modal.show();
      } else {
        modal.hide();
      }
    }
  }

  closeModal() {
    this.isClosed.emit();
  }
}
